import { fromJS } from 'immutable';
import * as pricingTableActions from '../actions/pricingTable';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState } from '@constants';

const initialState = {
  allYears: {},
  pricingTableDetails: {
    data: [],
    state: null,
  },
  editedPricingSchedule: {
    data: {},
    state: null,
  },
};

export default (
  state = fromJS(initialState),
  {
    type,
    data,
    pricingScheduleId,
    pricingAxisValueId,
    pricingScheduleDetailId,
  },
) => {
  let newState;
  switch (type) {
    case pricingTableActions.FETCH_ALL_YEARS[START]:
      return state.setIn(['allYears', 'state'], fetchingState.FETCHING);
    case pricingTableActions.FETCH_ALL_YEARS[SUCCESS]:
      newState = state.setIn(['allYears', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['allYears', 'data'],
        fromJS(data ? data.results : []),
      );
    case pricingTableActions.FETCH_ALL_YEARS[ERROR]:
      return state.setIn(['allYears', 'state'], fetchingState.ERROR);

    case pricingTableActions.FETCH_PRICING_SCHEDULES[START]:
      return state.setIn(['pricingSchedules', 'state'], fetchingState.FETCHING);

    case pricingTableActions.FETCH_PRICING_SCHEDULE[START]:
      return state.setIn(
        ['editedPricingSchedule', 'state'],
        fetchingState.FETCHING,
      );

    case pricingTableActions.FETCH_PRICING_SCHEDULES[SUCCESS]:
      newState = state.setIn(
        ['pricingSchedules', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['pricingSchedules', 'data'],
        fromJS(data ? data.results : []),
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULES[ERROR]:
      return state.setIn(['pricingSchedules', 'state'], fetchingState.ERROR);

    case pricingTableActions.FETCH_PRICING_SCHEDULES_CONFIG[START]:
      return state.setIn(
        ['pricingSchedulesConfig', 'state'],
        fetchingState.FETCHING,
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULES_CONFIG[SUCCESS]:
      newState = state.setIn(
        ['pricingSchedulesConfig', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['pricingSchedulesConfig', 'data'],
        fromJS(data ? data.results : []),
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULES_CONFIG[ERROR]:
      return state.setIn(
        ['pricingSchedulesConfig', 'state'],
        fetchingState.ERROR,
      );

    case pricingTableActions.FETCH_PRICING_SCHEDULES_AXIS_VALUES[START]:
      return state.setIn(
        ['pricingSchedulesAxisValues', 'state'],
        fetchingState.FETCHING,
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULES_AXIS_VALUES[SUCCESS]:
      newState = state.setIn(
        ['pricingSchedulesAxisValues', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['pricingSchedulesAxisValues', 'data'],
        fromJS(data ? data.results : []),
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULES_AXIS_VALUES[ERROR]:
      return state.setIn(
        ['pricingSchedulesAxisValues', 'state'],
        fetchingState.ERROR,
      );

    case pricingTableActions.DELETE_PRICING_SCHEDULE[SUCCESS]:
      return state.setIn(
        ['pricingSchedules', 'data'],
        fromJS(
          state
            .getIn(['pricingSchedules', 'data'])
            .toJS()
            .filter(p => p.pricingID !== pricingScheduleId),
        ),
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULE[SUCCESS]: {
      return state
        .setIn(['editedPricingSchedule', 'data'], fromJS(data.results[0]))
        .setIn(['editedPricingSchedule', 'state'], fetchingState.LOADED);
    }
    case pricingTableActions.UPDATE_PRICING_SCHEDULE[SUCCESS]:
      return state.setIn(
        ['editedPricingSchedule', 'data'],
        fromJS(data.results[0]),
      );

    case pricingTableActions.DUPLICATE_PRICING_SCHEDULE[SUCCESS]:
      return state.setIn(
        ['pricingSchedules', 'data'],
        fromJS([
          ...state.getIn(['pricingSchedules', 'data']).toJS(),
          ...(data ? data.results : []),
        ]),
      );

    case pricingTableActions.INSERT_PRICING_SCHEDULE[SUCCESS]:
      return state.setIn(
        ['pricingSchedules', 'data'],
        fromJS([
          ...state.getIn(['pricingSchedules', 'data']).toJS(),
          ...(data ? data.results : []),
        ]),
      );

    case pricingTableActions.FETCH_ALL_PRICING_SCHEDULE_DETAILS[START]:
      return state.setIn(
        ['pricingTableDetails', 'state'],
        fetchingState.FETCHING,
      );
    case pricingTableActions.FETCH_ALL_PRICING_SCHEDULE_DETAILS[SUCCESS]:
      newState = state.setIn(
        ['pricingTableDetails', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['pricingTableDetails', 'data'],
        fromJS(data ? data.results : []),
      );
    case pricingTableActions.FETCH_ALL_PRICING_SCHEDULE_DETAILS[ERROR]:
      return state.setIn(['pricingTableDetails', 'state'], fetchingState.ERROR);

    case pricingTableActions.INITIALIZE_PRICING_SCHEDULE[START]:
      return state.setIn(
        ['pricingTableDetails', 'state'],
        fetchingState.FETCHING,
      );
    case pricingTableActions.INITIALIZE_PRICING_SCHEDULE[SUCCESS]:
      newState = state.setIn(
        ['pricingTableDetails', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['pricingTableDetails', 'data'],
        fromJS(data ? data.results : []),
      );

    case pricingTableActions.UPDATE_PRICING_SCHEDULE_DETAIL[SUCCESS]:
      return state.setIn(
        ['pricingTableDetails', 'data'],
        fromJS(
          state
            .getIn(['pricingTableDetails', 'data'])
            .toJS()
            .map(v =>
              v.pricingDetailID === pricingScheduleDetailId
                ? data.results[0]
                : v,
            ),
        ),
      );

    case pricingTableActions.FETCH_PRICING_SCHEDULE_AXIS_VALUES[START]:
      return state.setIn(
        ['pricingScheduleAxisValues', 'state'],
        fetchingState.FETCHING,
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULE_AXIS_VALUES[SUCCESS]:
      newState = state.setIn(
        ['pricingScheduleAxisValues', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['pricingScheduleAxisValues', 'data'],
        fromJS(data ? data.results : []),
      );
    case pricingTableActions.FETCH_PRICING_SCHEDULE_AXIS_VALUES[ERROR]:
      return state.setIn(
        ['pricingScheduleAxisValues', 'state'],
        fetchingState.ERROR,
      );

    case pricingTableActions.INSERT_PRICING_SCHEDULE_AXIS_VALUE[SUCCESS]:
      return state.setIn(
        ['pricingScheduleAxisValues', 'data'],
        fromJS([
          ...state.getIn(['pricingScheduleAxisValues', 'data']).toJS(),
          ...(data ? data.results : []),
        ]),
      );

    case pricingTableActions.DELETE_PRICING_SCHEDULE_AXIS_VALUE[SUCCESS]:
      return state.setIn(
        ['pricingScheduleAxisValues', 'data'],
        fromJS(
          state
            .getIn(['pricingScheduleAxisValues', 'data'])
            .toJS()
            .filter(p => p.pricingAxisValueID !== pricingAxisValueId),
        ),
      );

    default:
      return state;
  }
};
